import { render, staticRenderFns } from "./newWindowIcon.vue?vue&type=template&id=489ba363&"
import script from "./newWindowIcon.vue?vue&type=script&lang=js&"
export * from "./newWindowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports